import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { UserManagement_PasswordResetData, UserManagement_UserCreationData, UserManagement_UpdateUserData, UserManagement_PasswordResetData_$reflection, UserManagement_UpdateUserData_$reflection, UserManagement_UserCreationData_$reflection, UserManagement_UserManagedRole_$reflection, UserManagement_UserInfo_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { union_type, string_type, unit_type, int32_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { UserEditModel_InitExisting_Z2556A9EA, UserEditModel_InitNew, Model, UserEditModel, EditUserDialogMsg, Msg, Model_get_Init } from "./Types.fs.js";
import { errorCmd, Loaded, request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { toggle } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { GlobalMessageBox_Info_Z721C83C5, GlobalMessageBox_ConfirmationBox, GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { value as value_3, some } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export function Http_loadUserlist() {
    const response = fetch("api/usermanagement", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(UserManagement_UserInfo_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_loadUserManagedRoles() {
    const response = fetch("api/usermanagement/managedroles", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(UserManagement_UserManagedRole_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_disableUser(userId) {
    return sendJson("api/usermanagement/disable", toString(0, Auto_generateBoxedEncoder_437914C6(int32_type, undefined, undefined, undefined)(userId)), singleton(new Types_RequestProperties(4, ["include"])), "PUT");
}

export function Http_enableUser(userId) {
    return sendJson("api/usermanagement/enable", toString(0, Auto_generateBoxedEncoder_437914C6(int32_type, undefined, undefined, undefined)(userId)), singleton(new Types_RequestProperties(4, ["include"])), "PUT");
}

export function Http_deleteUser(userId) {
    const response = fetch(toText(printf("api/usermanagement/%i"))(userId), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), singleton(new Types_RequestProperties(0, ["DELETE"]))), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_createNewUser(userCreationData) {
    const response = sendJson("api/usermanagement", toString(0, Auto_generateBoxedEncoder_437914C6(UserManagement_UserCreationData_$reflection(), undefined, undefined, undefined)(userCreationData)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_updateUser(updateUserData) {
    const response = sendJson("api/usermanagement/updateuser", toString(0, Auto_generateBoxedEncoder_437914C6(UserManagement_UpdateUserData_$reflection(), undefined, undefined, undefined)(updateUserData)), singleton(new Types_RequestProperties(4, ["include"])), "PUT");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_resetPassword(passwordResetData) {
    const response = sendJson("api/usermanagement/resetpassword", toString(0, Auto_generateBoxedEncoder_437914C6(UserManagement_PasswordResetData_$reflection(), undefined, undefined, undefined)(passwordResetData)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    return [Model_get_Init(), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_updateUserDialog(msg, model) {
    switch (msg.tag) {
        case 1:
            return [model, request(Http_loadUserManagedRoles, undefined, (arg) => (new Msg(11, [new EditUserDialogMsg(2, [arg])])))];
        case 2:
            return [new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, model.Sending, model.UserRoles, Loaded(msg.fields[0]), model.IsCurrentUser), Cmd_none()];
        case 3:
            return [new UserEditModel(model.Id, update(model.Login, msg.fields[0]), model.Email, model.Name, true, model.Sending, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), Cmd_none()];
        case 4:
            return [new UserEditModel(model.Id, (model.Login.Value === model.Email.Value) ? update(model.Login, msg.fields[0]) : model.Login, update(model.Email, msg.fields[0]), model.Name, true, model.Sending, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), Cmd_none()];
        case 5:
            return [new UserEditModel(model.Id, model.Login, model.Email, update(model.Name, msg.fields[0]), true, model.Sending, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), Cmd_none()];
        case 6:
            return [new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, model.Sending, toggle(msg.fields[0], model.UserRoles), model.AllUsermanagedRoles, model.IsCurrentUser), Cmd_none()];
        case 8: {
            const matchValue = model.Id;
            if (matchValue != null) {
                return [model, request(Http_updateUser, new UserManagement_UpdateUserData(matchValue, model.Login.Value, model.Name.Value, model.Email.Value, model.UserRoles), (arg_2) => (new Msg(11, [new EditUserDialogMsg(10, [arg_2])])))];
            }
            else {
                return [new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, true, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), request(Http_createNewUser, new UserManagement_UserCreationData(model.Email.Value, model.Name.Value, model.UserRoles), (arg_1) => (new Msg(11, [new EditUserDialogMsg(9, [arg_1])])))];
            }
        }
        case 9:
            if (msg.fields[0].tag === 1) {
                return [new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, false, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), errorCmd((Item_9) => (new Msg(14, [Item_9])), "Speichern", msg.fields[0].fields[0])];
            }
            else {
                const copyOfStruct = msg.fields[0].fields[0];
                if (copyOfStruct.tag === 1) {
                    const model_1 = new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, false, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser);
                    const msg_3 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(copyOfStruct.fields[0])])]);
                    return [model_1, singleton((dispatch_2) => {
                        dispatch_2(msg_3);
                    })];
                }
                else {
                    return [undefined, singleton((dispatch_1) => {
                        dispatch_1(new Msg(0, []));
                    })];
                }
            }
        case 10:
            if (msg.fields[0].tag === 1) {
                return [new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, false, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser), errorCmd((Item_12) => (new Msg(14, [Item_12])), "Speichern", msg.fields[0].fields[0])];
            }
            else {
                const copyOfStruct_1 = msg.fields[0].fields[0];
                if (copyOfStruct_1.tag === 1) {
                    const model_3 = new UserEditModel(model.Id, model.Login, model.Email, model.Name, model.IsDirty, false, model.UserRoles, model.AllUsermanagedRoles, model.IsCurrentUser);
                    const msg_6 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(copyOfStruct_1.fields[0])])]);
                    return [model_3, singleton((dispatch_4) => {
                        dispatch_4(msg_6);
                    })];
                }
                else {
                    return [undefined, singleton((dispatch_3) => {
                        dispatch_3(new Msg(0, []));
                    })];
                }
            }
        case 7:
            return [undefined, Cmd_none()];
        default:
            return [model, singleton((dispatch) => {
                dispatch(new Msg(11, [new EditUserDialogMsg(1, [])]));
            })];
    }
}

export function State_update(msg, model) {
    let matchResult, lst, id, id_1, user, user_1, errText, e, user_2, id_2, e_1, userInfo, m_1;
    switch (msg.tag) {
        case 0: {
            matchResult = 0;
            break;
        }
        case 1: {
            matchResult = 1;
            lst = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 2;
            id = msg.fields[0];
            break;
        }
        case 2: {
            matchResult = 3;
            id_1 = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 4;
            break;
        }
        case 5: {
            matchResult = 5;
            user = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 6;
            user_1 = msg.fields[0];
            break;
        }
        case 7: {
            if (msg.fields[0].tag === 1) {
                matchResult = 9;
                e = msg.fields[0].fields[0];
            }
            else {
                const copyOfStruct = msg.fields[0].fields[0];
                if (copyOfStruct.tag === 1) {
                    matchResult = 8;
                    errText = copyOfStruct.fields[0];
                }
                else {
                    matchResult = 7;
                }
            }
            break;
        }
        case 8: {
            matchResult = 10;
            user_2 = msg.fields[0];
            break;
        }
        case 9: {
            matchResult = 11;
            id_2 = msg.fields[0];
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 1) {
                matchResult = 13;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 12: {
            matchResult = 14;
            break;
        }
        case 13: {
            matchResult = 15;
            userInfo = msg.fields[0];
            break;
        }
        case 11: {
            if (model.ActiveUserDialog != null) {
                matchResult = 16;
                m_1 = msg.fields[0];
            }
            else {
                matchResult = 17;
            }
            break;
        }
        default:
            matchResult = 17;
    }
    switch (matchResult) {
        case 0:
            return [model, request(Http_loadUserlist, undefined, (Item) => (new Msg(1, [Item])))];
        case 1:
            return [new Model(Loaded(lst), model.ActiveUserDialog), Cmd_none()];
        case 2:
            return [model, request(Http_disableUser, id, (Item_1) => (new Msg(4, [Item_1])))];
        case 3:
            return [model, request(Http_enableUser, id_1, (Item_2) => (new Msg(4, [Item_2])))];
        case 4:
            return [model, singleton((dispatch) => {
                dispatch(new Msg(0, []));
            })];
        case 5: {
            const msg_2 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_ConfirmationBox("Benutzer-Passwort zurücksetzen", toText(printf("Soll das Passwort des Benutzers \'%s\' wirklich zurückgesetzt werden? Er kann sich dann nicht mehr mit seinem aktuellen Passwort anmelden."))(user.Email), some(new Msg(6, [user])))])]);
            return [model, singleton((dispatch_1) => {
                dispatch_1(msg_2);
            })];
        }
        case 6:
            return [model, request(Http_resetPassword, new UserManagement_PasswordResetData(user_1.KundenportalBenutzerId, user_1.Email), (Item_5) => (new Msg(7, [Item_5])))];
        case 7: {
            const msg_4 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_Info_Z721C83C5("Der Benutzer wurde per E-Mail gebeten, sein Passwort zu erneuern.")])]);
            return [model, singleton((dispatch_2) => {
                dispatch_2(msg_4);
            })];
        }
        case 8: {
            const msg_6 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(errText)])]);
            return [model, singleton((dispatch_3) => {
                dispatch_3(msg_6);
            })];
        }
        case 9:
            return [model, errorCmd((Item_10) => (new Msg(14, [Item_10])), "Senden", e)];
        case 10: {
            const msg_8 = new Msg(14, [new GlobalMsg(3, [GlobalMessageBox_ConfirmationBox("Benutzer löschen", toText(printf("Soll der Benutzer \'%s\' wirklich gelöscht werden?"))(user_2.Email), some(new Msg(9, [user_2.KundenportalBenutzerId])))])]);
            return [model, singleton((dispatch_4) => {
                dispatch_4(msg_8);
            })];
        }
        case 11:
            return [model, request(Http_deleteUser, id_2, (Item_13) => (new Msg(10, [Item_13])))];
        case 12:
            return [model, singleton((dispatch_5) => {
                dispatch_5(new Msg(0, []));
            })];
        case 13:
            return [model, errorCmd((Item_14) => (new Msg(14, [Item_14])), "Benutzer löschen", e_1)];
        case 14:
            return [new Model(model.Users, UserEditModel_InitNew()), singleton((dispatch_6) => {
                dispatch_6(new Msg(11, [new EditUserDialogMsg(0, [])]));
            })];
        case 15:
            return [new Model(model.Users, UserEditModel_InitExisting_Z2556A9EA(userInfo)), singleton((dispatch_7) => {
                dispatch_7(new Msg(11, [new EditUserDialogMsg(0, [])]));
            })];
        case 16: {
            const patternInput = State_updateUserDialog(m_1, value_3(model.ActiveUserDialog));
            return [new Model(model.Users, patternInput[0]), patternInput[1]];
        }
        default: {
            return [model, Cmd_none()];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
